<!-- eslint-disable prettier/prettier -->
<!-- eslint-disable vue/no-v-for-template-key -->
<!-- eslint-disable camelcase -->
<template>
  <div class="pls-search-page">
    <div id="generic-dialog" class="generic-dialog">
      <div class="generic-dialog__group generic-dialog__group__keywords">
        <input
          type="text"
          id="s"
          class="generic-dialog__group__input"
          name="search"
          v-model="this.search"
        />
        <label class="generic-dialog__group__label" for="s">Keywords</label>
      </div>

      <div class="generic-dialog__group generic-dialog__group__select">
        <select
          aria-label="Select Category"
          id="category"
          name="category"
          class="search-dialog__group__select"
          v-model="this.selectedCategories"
        >
          <option value="0">All Categories</option>
          <option
            v-for="category in categories"
            :key="category.id"
            :value="category.id"
          >
            <span v-if="category.parent">&nbsp;&nbsp;&nbsp;&nbsp;</span
            >{{ category.name }}
          </option>
        </select>
      </div>

      <div
        class="generic-dialog__group generic-dialog__group__button generic-dialog__group__button--search"
      >
        <button
          aria-label="search"
          class="generic-dialog__group__search-button"
          :disabled="loading"
          @click="searchPosts"
        >
          SEARCH
        </button>
      </div>

      <div
        class="generic-dialog__group generic-dialog__group__button generic-dialog__group__button--clear"
      >
        <button
          aria-label="reset search"
          type="reset"
          class="generic-dialog__group__clear-button"
          @click="clear"
        >
          Clear filters
        </button>
      </div>
    </div>

    <div v-if="total == 0 && !loading" class="no-results">
      Sorry, there are no developments that match the above criteria.
    </div>

    <TransitionGroup
      name="stagged-fade"
      tag="div"
      class="generic-results__list"
    >
      <template v-for="(post, index) in pls" :key="index">
        <article class="generic-results__list__article">
          <div class="generic-results__list__article__thumbnail-col">
            <img alt="Trial Logo" class="thumbnail" :src="post.featuredImage" />
          </div>

          <div class="generic-results__list__article__content-col">
            <h3 class="pls">{{ post.title }}</h3>
            <p v-html="post.excerpt"></p>
          </div>

          <div class="generic-results__list__article__actions-col">
            <a
              target="_blank"
              v-if="post.downloadUrl"
              @click="trackevent(post.downloadEventCode)"
              class="button button--external button--blue"
              :href="post.downloadUrl"
              >CLICK TO VIEW
            </a>
            <div v-else class="button button-blue">COMING SOON</div>
          </div>
        </article>
      </template>
    </TransitionGroup>

    <div v-if="loading" class="loading-spinner"></div>
  </div>
</template>

<script>
import { animationsV2 } from "../../animationsv2.js";

export default {
  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {},
  data() {
    return {
      pls: [],
      categories: [],
      params: {
        page: 1,
        per_page: 12,
        orderby: "menu_order",
        order: "asc",
      },
      selectedCategories: 0,
      search: "",
      loading: false,
      total: 0,
      totalPages: 0,
      staggerDelay: 50,
    };
  },
  mounted() {
    this.getCategories();

    if (this.config.developmentStatusID) {
      this.selectedStatusID = this.config.developmentStatusID;
    }

    this.getPosts();
  },
  computed: {
    showMore() {
      return this.params.page < this.totalPages || this.loading;
    },
  },
  methods: {
    async getCategories() {
      this.categories = [];

      await this.axios
        .get("pls_categories", {
          params: { orderby: "term_group", hide_empty: 1 },
        })
        .then((response) => {
          this.categories = response.data;
        });
    },
    trackevent(code) {
      this.$gtag.event(code);
    },
    async getPosts() {
      this.loading = true;

      if (this.search != "") {
        this.params.search = this.search;
      } else {
        this.params.search;
      }
      const params = { ...this.params };

      await this.axios
        .get("pls", {
          params,
        })
        .then((response) => {
          const posts = [];

          response.data.forEach((post) => {
            posts.push({
              featuredImage: post.featured_image,
              link: post.link,
              title: post.title.rendered,
              excerpt: post.excerpt.rendered,
              downloadEventCode: post.download_event_code,
              downloadUrl: post.download_url,
            });
          });
          this.pls = this.pls.concat(posts);
          this.total = parseInt(response.headers["x-wp-total"], 10);
          this.totalPages = parseInt(response.headers["x-wp-totalpages"], 10);
        });

      animationsV2();
      this.loading = false;
    },
    searchPosts() {
      this.pls = [];
      this.params.page = 1;
      this.getPosts();
    },
    clear() {
      this.search = "";
      this.params = { ...this.default_params };
      this.params.page = 1;
      this.pls = [];
      this.getPosts();
    },
  },
};
</script>
